<template>
  <div class="page" data-name="home">
    <div class="navbar" style="background: #fff" v-if="user.isEmployee">
      <div class="navbar-inner sliding">
        <div class="logotitle">
          <!-- <h5 class="leftnavTitle">LOVESTRUCK</h5> -->
          <img
            src="https://cdn-cf2.lovestruck.com/upload-m/gen/img/ls_com_black/LSM_logo.png?d12d"
            style="width: 268px; position: relative"
          />
          <br />
        </div>
        <div class="select title">
          <select
            name="slct"
            id="slct"
            v-model="userCity"
            @change="changeCity()"
          >
            <option
              v-for="city in cityList"
              :key="city.city_id"
              :value="city.city_id"
            >
              {{ city.city_name }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="tabs memebersTab" style="padding-top: 82px">
      <div
        id="tab-1"
        style="height: 100%"
        infinite
        :infinite-distance="100"
        :infinite-preloader="showPreloader"
        @infinite="loadMore"
        class="page-content infinite-scroll-content tab tab-active"
      >
        <form class="search-container">
          <f7-block strong style="margin: 0; padding: 0">
            <div class="membership_tab_container">
              <input
                id="tab_allmembership"
                type="radio"
                name="membership"
                value="0"
                :checked="membershipLevel == 0"
                @change="filterByMembership($event.target.value)"
              />
              <label for="tab_allmembership" style="width: 20%; height: 36px">
                <span>All</span>
              </label>
              <input
                id="tab_diamond"
                type="radio"
                name="membership"
                value="4"
                @change="filterByMembership($event.target.value)"
              />
              <label
                for="tab_diamond"
                style="
                  width: 20%;
                  height: 36px;
                  font-size: 15px;
                  color: #5576ba;
                "
              >
                <span>Diamond</span>
              </label>
              <input
                id="tab_gold"
                type="radio"
                name="membership"
                value="3"
                :checked="membershipLevel == 3"
                @change="filterByMembership($event.target.value)"
              />
              <label
                for="tab_gold"
                style="width: 20%; height: 36px; color: #e61e5a"
              >
                <span>Plus</span>
              </label>
              <!-- <input
                id="tab_silver"
                type="radio"
                name="membership"
                value="2"
                @change="filterByMembership($event.target.value)"
              />
              <label for="tab_silver">
                <span>Silver</span>
              </label>-->
              <input
                id="tab_basic"
                type="radio"
                name="membership"
                value="2"
                :checked="membershipLevel == 2"
                @change="filterByMembership($event.target.value)"
              />
              <label
                for="tab_basic"
                style="width: 20%; height: 36px; color: #daa520"
              >
                <span>Starter</span>
                <!-- <small style="display: block">verified</small> -->
              </label>

              <input
                id="tab_basic0"
                type="radio"
                name="membership"
                value="1"
                :checked="membershipLevel == 1"
                @change="filterByMembership($event.target.value)"
              />
              <label
                for="tab_basic0"
                style="width: 20%; height: 36px; color: #169f46"
              >
                <span>Free</span>
                <!-- <small style="display: block">unverified</small> -->
              </label>
            </div>
          </f7-block>
          <input
            type="text"
            id="search-bar"
            autocomplete="off"
            v-model="searchKeyword"
            placeholder="Search or start new chat"
            @input="searchContact(searchKeyword, false, true, true)"
            @keydown.enter.exact.prevent="
              searchContact(searchKeyword, false, true, true)
            "
          />
          <div
            id="refreshButton"
            @click="filterByMembership('')"
            title="Refresh contact list!"
          >
            <input type="button" name value="Refresh contacts" />
            <br />
            <i class="fa fa-retweet refresh" aria-hidden="true"></i>
          </div>
          <a href="javascript:void(0)">
            <i class="fas fa-search search-icon" v-if="!isSearch"></i>
            <i
              class="fas fa-arrow-left search-icon"
              v-if="isSearch"
              @click="clearSearchKeyword()"
            ></i>
          </a>
        </form>

        <div class="tab_container">
          <input
            id="tab_all"
            type="radio"
            name="tabs"
            @change="changeTab(1)"
            checked
          />
          <label for="tab_all" style="width: 34%; font-size: 13px">
            <span>All Members</span>
          </label>
          <input
            id="tab_mymembers"
            type="radio"
            name="tabs"
            @change="changeTab(3)"
          />
          <label for="tab_mymembers" style="width: 33%; font-size: 13px">
            <span>My Members</span>
          </label>
          <input
            id="tab_mychats"
            type="radio"
            name="tabs"
            @change="changeTab(2)"
          />
          <label for="tab_mychats" style="width: 33%; font-size: 13px">
            <span>My Chats</span>
          </label>

          <section id="all" class="tab-content">
            <!-- All Contacts -->
            <all-contacts
              :isSearch="isSearch"
              :loading="loading"
              :user="user"
              :userList="userList"
              @activeUser="active"
            />
          </section>
          <section id="mychats" class="tab-content">
            <!-- My Chats Contacts  -->
            <my-chats
              :isSearch="isSearch"
              :myChatLoading="myChatLoading"
              :user="user"
              :myChatsList="myChatsList"
              @activeUser="active"
            />
          </section>
          <section id="mymembers" class="tab-content">
            <!-- My Members Contacts -->
            <my-members
              :isSearch="isSearch"
              :myMembersLoading="myMembersLoading"
              :user="user"
              :myMemberList="myMemberList"
              @activeUser="active"
            />
          </section>
        </div>
        <!-- Search Contact List  -->
        <search-list
          :isSearch="isSearch"
          :searchLoading="searchLoading"
          :user="user"
          :contactsSearchedFromName="contactsSearchedFromName"
          :contactsSearchedFromMessage="contactsSearchedFromMessage"
          @activeUser="active"
        />

        <div class="preloader infinite-scroll-preloader"></div>
      </div>
    </div>
  </div>
</template>
<style scoped src="../../assets/css/leftnavChat.css">
</style>
<script>
// import io from "socket.io-client";
import { Url, DefaultValue, ChatOptions } from "../../core/const";

import allContact from "./components/all";
import myChat from "./components/myChat";
import myMembers from "./components/myMembers";
import searchContactList from "./components/searchContactList";
import { voipMixin, mixin, tencentIM } from "../../utils/mixin";
// import voipModal from "./voip";
// import TIM from "tim-js-sdk";
// import TIMUploadPlugin from "tim-upload-plugin";
export default {
  components: {
    "all-contacts": allContact,
    "my-chats": myChat,
    "my-members": myMembers,
    "search-list": searchContactList,
    // voipModal,
  },
  mixins: [voipMixin, mixin, tencentIM],
  data() {
    return {
      user: JSON.parse(localStorage.getItem("user")),
      userInfo: JSON.parse(localStorage.getItem("userInfoData")),
      mmInfo: JSON.parse(localStorage.getItem("mmInfo")),
      searchKeyword: "",
      selectedUser: {},
      userList: [],
      page: 1,
      MyChatPage: 1,
      searchPage: 1,
      membersPage: 1,
      isReceivedNewMessage: false,
      items: [],
      type: "",
      loading: true,
      myChatLoading: true,
      searchLoading: true,
      myMembersLoading: true,
      hasMoreItems: true,
      hasMoreMyItems: true,
      hasMoreMyMembers: true,
      allowInfinite: true,
      lastItem: 100,
      showPreloader: true,
      cityList: [],
      isSearch: false,
      isTyping: false,
      activeClientId: null,
      contactsSearchedFromMessage: [],
      contactsSearchedFromName: [],
      myChatsList: [],
      myMemberList: [],
      membershipLevel: 0,
      hasMoreSearchItem: true,
      chatOption: 1,
      deviceList: [],
      activeCity: null,
      userCity:
        JSON.parse(localStorage.getItem("userInfoData")).data
          .availableCityIds &&
        JSON.parse(localStorage.getItem("userInfoData")).data
          .availableCityIds[0],
      site: JSON.parse(localStorage.getItem("cur-site")),
      effect: "blink",
      authdata: {
        token: JSON.parse(localStorage.getItem("user")).token,
      },
      socket: null,
      isTest: false,
      cnpath: 0,
      notRespondedContactEnd: false,
      notRespondedClientIds: [],
      imMode: "tim",
      tim: null,
      currentUser: null,
      loopTimer: null,
      callLoopTimerNum: 1,
      loadConversationListNuM: 0,
      TIMMessageList: [],
      currentTIMConversationID: null,
      TIMNextReqMessageID: null,
      TIMMessageListIsCompleted: false,
    };
  },
  onPageInit: function (app, page) {
    console.log("init");
  },
  methods: {
    onTIMMessageReceived(event) {
      let self = this;

      if (!event.data) {
        return false;
      }
      console.log("onMessageReceived and get refresh list", event.data);
      self.getTIMConversationList();
      //   for (var msg of event.data) {
      //     if (msg.conversationID == self.currentTIMConversationID) {
      //       self.TIMMessageList = [...self.TIMMessageList, ...[msg]];
      //       self.scrollToBottom();

      //       self.setTIMMessageRead();
      //     }

      //   }
    },

    onTIMSdkReady() {
      let self = this;
      console.log("ready...");
      self.getTIMConversationList();
      //   self.loopTIMConversationList(2000);
      //   if (self.targetClientId > 0 || self.targetClientId == self.employeeTag) {
      //     self.getTIMMessageList();
      //   }
    },
    onSdkNotReady() {
      console.log("onSdkNotReady");
      this.TIMLogin();
    },

    getTIMConversationList() {
      let self = this;
      //   self.isLoadingContact = true;
      let promise = self.tim.getConversationList();
      self.loadConversationListNuM++;
      promise
        .then(function (imResponse) {
          let conversationList = _.get(
            imResponse,
            "data.conversationList",
            null
          ); // 全量的会话列表，用该列表覆盖原有的会话列表
          //   console.log("conversationList=", conversationList);
          //   conversationList = null;
          //   console.log(
          //     "conversationList=",
          //     //     "self.loadConversationListNuM % 60 = ",
          //     //     self.loadConversationListNuM % 60,
          //     conversationList
          //   );
          //   self.hasContacts = true;
          //   self.isLoadingContact = false;
          if (!conversationList) {
            return false;
          }
          //   if (!conversationList && self.loadConversationListNuM % 60 == 0) {
          //     // console.log("ssssssssssssssssssss", self.loopTimer);
          //     // clearInterval(self.loopTimer);
          //     self.loopTIMConversationList(5000);
          //     return false;
          //   }
          //   self.contacts = [];
          //   self.employeeContacts = [];

          for (var item of conversationList) {
            let type = 1;
            let msg = "";
            if (_.get(item, "lastMessage.type") == "TIMTextElem") {
              type = 1;
              msg = _.get(item, "lastMessage.payload.text");
              //
            } else if (_.get(item, "lastMessage.type") == "TIMImageElem") {
              type = 2;
              msg = "PHOTO";
            }
            let client_id = 0;
            //     //for c2c
            //     if (item.conversationID.indexOf("C2Cc_") > -1) {
            //       let client_id = parseInt(
            //         item.conversationID.replace("C2Cc_", "")
            //       );
            //       //   let c_index = _.findIndex(self.contacts, {
            //       //     target_client_id: client_id,
            //       //   });
            //       let first_name = _.get(item, "userProfile.nick", "");
            //       let text = $.trim(self.listQuery.search_text);
            //       //search
            //       if (
            //         !text ||
            //         (text &&
            //           (first_name.indexOf(text) > -1 || msg.indexOf(text) > -1))
            //       ) {
            //         self.contacts.push({
            //           sent_time: _.get(item, "lastMessage.lastTime"),
            //           unread_count: _.get(item, "unreadCount", 0),
            //           type: type,
            //           msg: msg,
            //           target_client_id: client_id,
            //           target: {
            //             client_id: client_id,
            //             first_name: first_name,
            //             photo_url: _.get(item, "userProfile.avatar"),
            //           },
            //         });
            //       }
            //     }
            //     //TODO for group
            let chat_type = "c2c";
            if (item.conversationID.indexOf("GROUPM2CG_") > -1) {
              client_id = parseInt(
                item.conversationID.replace("GROUPM2CG_", "")
              );
              chat_type = "group";
              //   console.log("self.userList", self.userList);
            } else if (item.conversationID.indexOf("C2Cc_") > -1) {
              client_id = parseInt(item.conversationID.replace("C2Cc_", ""));
            }

            if (!client_id) {
              continue;
            }

            let u_index = _.findIndex(self.userList, {
              client_id: client_id,
            });
            let m_index = _.findIndex(self.myMemberList, {
              client_id: client_id,
            });
            let c_index = _.findIndex(self.myChatsList, {
              client_id: client_id,
            });
            let fromAccount = _.get(item, "lastMessage.fromAccount", "");
            // console.log("fromAccount=", fromAccount);
            if (!fromAccount) {
              console.log("item", item);
            }
            let isFromClient = fromAccount.indexOf("c_") > -1 ? true : false;

            let from_client_id = isFromClient ? client_id : 0;
            let from_employee_id = isFromClient
              ? 0
              : fromAccount.replace("e_", "");

            //   console.log(
            //     "index",
            //     client_id,
            //     u_index,
            //     m_index,
            //     c_index,
            //     from_client_id,
            //     from_employee_id
            //   );
            let lastTime = _.get(item, "lastMessage.lastTime");
            if (
              u_index > -1 &&
              self.userList[u_index]["sent_time"] < lastTime
            ) {
              self.userList[u_index]["from_client_id"] = from_client_id;
              self.userList[u_index]["from_employee_id"] = from_employee_id;
              self.userList[u_index]["chat_type"] = chat_type;
              self.userList[u_index]["type"] = type;
              self.userList[u_index]["msg"] = msg;
              self.userList[u_index]["sent_time"] = lastTime;
              self.userList[u_index]["unread_count"] = _.get(
                item,
                "unreadCount",
                0
              );
            }

            if (
              m_index > -1 &&
              self.myMemberList[m_index]["sent_time"] < lastTime
            ) {
              self.myMemberList[m_index]["from_client_id"] = from_client_id;
              self.myMemberList[m_index]["from_employee_id"] = from_employee_id;
              self.myMemberList[m_index]["chat_type"] = chat_type;
              self.myMemberList[m_index]["type"] = type;
              self.myMemberList[m_index]["msg"] = msg;
              self.myMemberList[m_index]["sent_time"] = _.get(
                item,
                "lastMessage.lastTime"
              );
              self.myMemberList[m_index]["unread_count"] = _.get(
                item,
                "unreadCount",
                0
              );
            }

            if (
              c_index > -1 &&
              self.myChatsList[c_index]["sent_time"] < lastTime
            ) {
              self.myChatsList[c_index]["from_client_id"] = from_client_id;
              self.myChatsList[c_index]["from_employee_id"] = from_employee_id;
              self.myChatsList[c_index]["chat_type"] = chat_type;
              self.myChatsList[c_index]["type"] = type;
              self.myChatsList[c_index]["msg"] = msg;
              self.myChatsList[c_index]["sent_time"] = _.get(
                item,
                "lastMessage.lastTime"
              );
              self.myChatsList[c_index]["unread_count"] = _.get(
                item,
                "unreadCount",
                0
              );
            }

            //     // console.log("self.contacts=", self.contacts);
          }
        })
        .catch(function (imError) {
          console.warn("getConversationList error:", imError); // 获取会话列表失败的相关信息
        });
    },
    testLog() {
      if (this.isTest) {
        let str = "";
        for (let arg of arguments) {
          str += `${arg} `;
        }
        console.log(str);
      }
    },
    requestBoth(isMychat) {
      const app = this;
      this.axios
        .all([this.allContacts(isMychat), this.notRespondedContacts(isMychat)])
        .then(
          this.axios.spread(function (allContacts, notRespondedContacts) {
            app.testLog(".............Both requests are now complete.....");
            console.log("complete......");
            // Both requests are now complete
            // let notRespondedContactsArr = _.get(
            //   notRespondedContacts,
            //   "data.contacts",
            //   []
            // );
            let result = [
              ...allContacts.data.contacts,
              ...notRespondedContacts.data.contacts,
            ];
            // console.log("result len=", result.length);
            if (result.length == 0) {
              app.hasMoreItems = false;
              app.loading = false;
            }

            if (result.length > 0) {
              app.hasMoreItems = true;

              if (app.page == 1) {
                app.userList = [];
              }
              app.userList = [...app.userList, ...result];
              // console.log("app.userList len1=", app.userList.length);
              app.removeDuplicates(app.userList).then((res) => {
                app.userList = res;
                app.loading = false;
                // console.log("app.userList len2=", app.userList.length);
              });
            } else {
              app.hasMoreItems = false;
              app.loading = false;
            }
          })
        );
    },
    async getUsers(isMychat) {
      const app = this;
      app.testLog("=======getUsers");
      if (app.user.isEmployee && app.hasMoreItems) {
        // app.requestBoth(isMychat);
        app.requestOneByOne(isMychat);
      }
    },
    requestOneByOne(isMychat) {
      const app = this;

      if (app.notRespondedContactEnd) {
        app.allContacts(isMychat).then((allContacts) => {
          let result = _.get(allContacts, "data.contacts");

          if (result && result.length > 0) {
            app.hasMoreItems = true;

            // if (app.page == 1) {
            //   app.userList = [];
            // }
            let filterRes = [];
            for (let row of result) {
              let clientId = 0;
              if (row.from_client_id > 0) {
                clientId = row.from_client_id;
              } else if (row.to_client_id > 0) {
                clientId = row.to_client_id;
              }

              if (app.notRespondedClientIds.includes(clientId) == false) {
                filterRes.push(row);
              }
            }

            app.userList = [...app.userList, ...filterRes];
            // console.log("app.userList len1=", app.userList.length);
            // app.removeDuplicates(app.userList).then((res) => {
            //   app.userList = res;
            //   app.loading = false;
            //   // console.log("app.userList len2=", app.userList.length);
            // });
          } else {
            app.hasMoreItems = false;
            app.loading = false;
          }
        });
      } else {
        app.notRespondedContacts(isMychat).then((notRespondedContacts) => {
          let result = _.get(notRespondedContacts, "data.contacts");

          if (result && result.length > 0) {
            app.hasMoreItems = true;
            app.notRespondedContactEnd = false;

            if (app.page == 1) {
              app.userList = [];
            }
            app.userList = [...app.userList, ...result];
            // console.log("app.userList len1=", app.userList.length);
            app.removeDuplicates(app.userList).then((res) => {
              app.userList = res;
              app.loading = false;
              // console.log("app.userList len2=", app.userList.length);
            });
          } else {
            // app.hasMoreItems = false;
            app.notRespondedContactEnd = true;
            app.page = 0;
            app.loading = false;
            app.loadMoreAll();
          }
        });
      }
    },
    allContacts(isMychat) {
      const app = this;
      let url = "";

      if (isMychat) {
        url = `/api/v2/${app.type}/contacts?page=${app.MyChatPage}&city_id=${
          app.userCity
        }&membership_level_id=${
          app.membershipLevel == 0 ? "" : app.membershipLevel
        }&messaged_only=1&employee_id=${app.user.id}&not_responded=0&iscn=${
          app.cnpath
        }`;
      } else {
        url = `/api/v2/${app.type}/contacts?page=${app.page}&city_id=${
          app.userCity
        }&membership_level_id=${
          app.membershipLevel == 0 ? "" : app.membershipLevel
        }&not_responded=0&iscn=${app.cnpath}`;
      }
      app.testLog("=======allContacts", isMychat, url);
      return this.$http.get(url);
    },
    notRespondedContacts(isMychat) {
      const app = this;
      let url = "";
      if (isMychat) {
        url = `/api/v2/${app.type}/contacts?page=${app.page}&city_id=${
          app.userCity
        }&membership_level_id=${
          app.membershipLevel == 0 ? "" : app.membershipLevel
        }&messaged_only=1&employee_id=${app.user.id}&not_responded=1&iscn=${
          app.cnpath
        }`;
      } else {
        url = `/api/v2/${app.type}/contacts?page=${app.page}&city_id=${
          app.userCity
        }&membership_level_id=${
          app.membershipLevel == 0 ? "" : app.membershipLevel
        }&not_responded=1&iscn=${app.cnpath}`;
      }
      app.testLog("=======notRespondedContacts", isMychat, url);
      return this.$http.get(url);
    },
    employeeMembers() {
      const app = this;
      app.testLog("===========employeeMembers");
      this.$http
        .get(
          `/api/v2/${app.type}/contacts?page=${app.membersPage}&city_id=${app.userCity}&employee_id=${app.user.id}&not_responded=1&filter_my_chat=1&t=4`
        )
        .then((response) => {
          let result = response.data.contacts;
          if (!result || result.length == 0) {
            console.log("hasMoreMyMembers false");
            app.hasMoreMyMembers = false;
            app.myMembersLoading = false;
          }
          if (result.length > 0) {
            app.hasMoreMyMembers = true;

            if (app.membersPage == 1) {
              app.myMemberList = [];
            }
            app.myMemberList = [...app.myMemberList, ...result];
            app.removeDuplicates(app.myMemberList).then((res) => {
              // app.myMemberList = app.filterMyChatsContactNotResponded(res);
              // if (app.myMemberList.length < 10 && response.data.total > 200) {
              //   app.membersPage += 1;
              //   setTimeout(() => {
              //     app.testLog("===========employeeMembers again");
              //     app.employeeMembers();
              //   }, 200);
              // }
              app.myMemberList = res;
              app.myMembersLoading = false;
            });
            // app.myChatsList = app.filterYourChats(app.userList);
          } else {
            app.hasMoreMyMembers = false;
            app.myMembersLoading = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    myChats(isMychat) {
      const app = this;
      app.testLog("===========myChats");
      // app.chatOption = ChatOptions.MyChats;
      this.axios.all([this.allContacts(isMychat)]).then(
        this.axios.spread(function (allContacts) {
          let result = allContacts.data.contacts;
          if (!result || result.length == 0) {
            app.hasMoreMyItems = false;
            app.myChatLoading = false;
          }
          if (result.length > 0) {
            app.hasMoreMyItems = true;

            if (app.MyChatPage == 1) {
              app.myChatsList = [];
            }
            app.myChatsList = [...app.myChatsList, ...result];
            app.removeDuplicates(app.myChatsList).then((res) => {
              app.myChatsList = app.filterMyChatsContactNotResponded(res);
              // if (app.myChatsList.length < 10 && allContacts.data.total > 200) {
              //   app.MyChatPage += 1;
              //   setTimeout(() => {
              //     app.testLog("===========myChats again");
              //     app.myChats(true);
              //   }, 200);
              // }
              app.myChatLoading = false;
            });
            // app.myChatsList = app.filterYourChats(app.userList);
          } else {
            app.hasMoreMyItems = false;
            app.myChatLoading = false;
          }
        })
      );
    },
    removeDuplicates(list) {
      var ids = [];
      var cleanList = [];
      const app = this;
      return new Promise((resolve) => {
        if (app.user.isEmployee) {
          list.forEach((element, index) => {
            if (
              ids.includes(element.from_client_id) == false ||
              ids.includes(element.to_client_id) == false
            ) {
              if (ids.includes(element.from_client_id) == false) {
                ids.push(element.from_client_id);
              }
              if (ids.includes(element.to_client_id) == false) {
                ids.push(element.to_client_id);
              }
              cleanList.push(element);
            }
          });
          app.notRespondedClientIds = ids;
        }
        // console.log("app.notRespondedClientIds=", app.notRespondedClientIds);
        //app.loading = false;
        let fromClientList = cleanList.filter((item) => {
          return item.from_client_id;
        });

        let notfromClientList = cleanList.filter((item) => {
          return !item.from_client_id;
        });
        resolve([
          ..._.sortBy(fromClientList, "sent_time").reverse(),
          ...notfromClientList,
        ]);
      });
    },
    filterMyChatsContactNotResponded(list) {
      const app = this;
      let employee_id = app.userInfo.data.employee_id;
      let result = list.filter((item) => {
        return (
          item.from_employee_id == employee_id ||
          item.to_employee_id == employee_id
        );
      });
      return result;
    },
    loadMore() {
      const app = this;
      app.testLog("============loadMore", app.chatOption);
      if (app.chatOption == ChatOptions.MyChats) {
        this.loadMoreMyChat();
      } else if (app.chatOption == ChatOptions.All) {
        this.loadMoreAll();
      }
      // if (app.chatOption == ChatOptions.MyChats) {
      //   this.loadMoreMyChat();
      // }
      else if (app.chatOption == ChatOptions.Members) {
        this.loadMoreMyMember();
      }
    },
    loadMoreAll() {
      const self = this;
      self.testLog("========loadMoreAll", self.chatOption);
      if (!self.isSearch) {
        if (!self.allowInfinite) return;
        self.allowInfinite = false;
        setTimeout(() => {
          //   if (self.userList.length >= 200) {
          //     self.showPreloader = false;
          //     return;
          //   }
          this.page++;
          this.getUsers(false);
          this.loading = false;
          self.allowInfinite = true;
        }, 1000);
      } else {
        if (!self.allowInfinite) return;
        self.allowInfinite = false;
        setTimeout(() => {
          this.page++;
          this.searchContact(
            self.searchKeyword,
            true,
            self.hasMoreSearchItem,
            false
          );
          this.searchLoading = false;
          self.allowInfinite = true;
        }, 1000);
      }
    },
    loadMoreMyChat() {
      const self = this;
      self.testLog("=============loadMoreMyChat", self.chatOption);
      if (!self.isSearch) {
        if (!self.allowInfinite) return;
        self.allowInfinite = false;
        setTimeout(() => {
          //   if (self.myChatsList.length >= 200) {
          //     self.showPreloader = false;
          //     return;
          //   }
          this.MyChatPage++;
          this.myChats(true);
          this.myChatLoading = false;
          self.allowInfinite = true;
        }, 1000);
      } else {
        if (!self.allowInfinite) return;
        self.allowInfinite = false;
        setTimeout(() => {
          this.MyChatPage++;
          this.searchContact(
            self.searchKeyword,
            true,
            self.hasMoreSearchItem,
            false
          );
          this.searchLoading = false;
          self.allowInfinite = true;
        }, 1000);
      }
    },
    loadMoreMyMember() {
      const self = this;
      self.testLog("==============loadMoreMyMember", self.chatOption);
      if (!self.isSearch) {
        if (!self.allowInfinite) return;
        self.allowInfinite = false;
        setTimeout(() => {
          //   if (self.myMemberList.length >= 200) {
          //     self.showPreloader = false;
          //     return;
          //   }
          this.membersPage++;
          this.employeeMembers();
          this.myMembersLoading = false;
          self.allowInfinite = true;
        }, 1000);
      } else {
        if (!self.allowInfinite) return;
        self.allowInfinite = false;
        setTimeout(() => {
          this.membersPage++;
          this.searchContact(
            self.searchKeyword,
            true,
            self.hasMoreSearchItem,
            false
          );
          this.searchLoading = false;
          self.allowInfinite = true;
        }, 1000);
      }
    },
    changeTab(option) {
      const app = this;
      app.chatOption = option;
      app.isSearch = false;
      app.testLog("===========changeTab=====");
      if (app.chatOption == ChatOptions.MyChats) {
        this.clearContacts(app.chatOption);
        app.hasMoreMyItems = true;
        app.myChatLoading = true;
        app.myChats(true);
      } else if (app.chatOption == ChatOptions.All) {
        this.clearContacts(app.chatOption);
        app.hasMoreItems = true;
        app.notRespondedContactEnd = false;
        app.loading = true;
        app.getUsers(false);
      } else if (app.chatOption == ChatOptions.Members) {
        this.clearContacts(app.chatOption);
        app.hasMoreMyMembers = true;
        app.myMembersLoading = true;
        app.employeeMembers();
      }
    },
    active(data) {
      let id = data.user.client_id;
      let user = data.user;
      const app = this;

      //   console.log("active", data);

      //   if (!_.get(user, "tencent_im_groupID")) {
      //     if (
      //       _.get(user, "client.membership_level.membership_level_id", 0) >= 2
      //     ) {
      //       app.$http
      //         .get(`/api/v2/employee/applyCreateTIMGroup?client_id=${id}`)
      //         .then((rs) => {
      //           // console.log("rs", rs);
      //           if (_.get(rs, "data.success", false)) {
      //             if (app.isSearch) {
      //               let index = _.findIndex(app.contactsSearchedFromName, {
      //                 client: { client_id: id },
      //               });
      //               if (index >= 0) {
      //                 app.contactsSearchedFromName[index]["tencent_im_groupID"] =
      //                   _.get(rs, "data.group_info.GroupId", "");
      //               }
      //             } else {
      //               if (data.type == "all") {
      //                 app.userList[data.index]["tencent_im_groupID"] = _.get(
      //                   rs,
      //                   "data.group_info.GroupId",
      //                   ""
      //                 );
      //               } else if (data.type == "member") {
      //                 app.myMemberList[data.index]["tencent_im_groupID"] = _.get(
      //                   rs,
      //                   "data.group_info.GroupId",
      //                   ""
      //                 );
      //               } else if (data.type == "chat") {
      //                 app.myChatsList[data.index]["tencent_im_groupID"] = _.get(
      //                   rs,
      //                   "data.group_info.GroupId",
      //                   ""
      //                 );
      //               }
      //             }

      //           }
      //         });
      //     }
      //   }

      //   return false;
      //TODO check groupID, and membership level id
      // if(user.)

      localStorage.setItem("tabStatus", "1");
      localStorage.setItem("activeClient", id.toString());
      // console.log("active id=", id);
      //update count
      //client.client_id
      if (app.isSearch) {
        let index = _.findIndex(app.contactsSearchedFromName, {
          client: { client_id: id },
        });
        if (index >= 0) {
          app.contactsSearchedFromName[index]["unread_count"] = 0;
        }
      } else {
        if (app.chatOption == ChatOptions.All) {
          let index = _.findIndex(app.userList, { client: { client_id: id } });
          if (index >= 0) {
            app.userList[index]["unread_count"] = 0;
          }
        }
        if (app.chatOption == ChatOptions.MyChats) {
          let index = _.findIndex(app.myChatsList, {
            client: { client_id: id },
          });
          if (index >= 0) {
            app.myChatsList[index]["unread_count"] = 0;
          }
        }
        if (app.chatOption == ChatOptions.Members) {
          let index = _.findIndex(app.myMemberList, {
            client: { client_id: id },
          });
          if (index >= 0) {
            app.myMemberList[index]["unread_count"] = 0;
          }
        }
      }

      this.readConversation(id);

      var uri = window.location.toString();

      var clean_uri = uri.substring(0, uri.indexOf("?clientId"));
      clean_uri = `${clean_uri}?clientId=${id}`;
      window.history.pushState({}, document.title, clean_uri);
    },
    async readConversation(id) {
      const app = this;
      var bodyFormData = new FormData();
      bodyFormData.set("clientId", id);
      if (app.user.isEmployee) {
        await this.$http
          .post(`/api/v2/employee/readConversation`, bodyFormData, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          })
          .then((response) => {
            // if (app.chatOption == ChatOptions.MyChats) {
            //   app.MyChatPage = 1;
            //   this.myChats(true);
            // }
            // if (app.chatOption == ChatOptions.All) {
            //   app.page = 1;
            //   this.getUsers(false);
            // }
            //this.getUsers();
          })
          .catch(function (error) {
            console.log(error.response);
          });
      }
    },

    searchContact(searchKeyword, isScrolling, hasMoreData, newSearch) {
      const app = this;
      if (newSearch) {
        app.contactsSearchedFromMessage = [];
        app.contactsSearchedFromName = [];
      }
      if (searchKeyword.length > 0) {
        app.isSearch = true;
        if (!isScrolling) {
          app.searchPage = 1;
          app.contactsSearchedFromMessage = [];
          app.contactsSearchedFromName = [];
        }
        if (app.user.isEmployee && hasMoreData) {
          clearTimeout(app.timeout);

          // Make a new timeout set to go off in 800ms
          app.timeout = setTimeout(function () {
            if (app.searchKeyword.length > 0) {
              app.searchLoading = true;

              app.$http
                .get(
                  `/api/v2/${app.type}/searchContacts?page=${app.searchPage}&city_id=${app.userCity}&keyword=${searchKeyword}`
                )
                .then((response) => {
                  app.searchLoading = false;
                  if (
                    response.data.contactsSearchedFromName.length < 200 &&
                    response.data.contactsSearchedFromMessage.length < 200
                  ) {
                    app.hasMoreSearchItem = false;
                  }
                  app.contactsSearchedFromName = [
                    ...app.contactsSearchedFromName,
                    ...response.data.contactsSearchedFromName,
                  ];
                  app.contactsSearchedFromMessage = [
                    ...app.contactsSearchedFromMessage,
                    ...response.data.contactsSearchedFromMessage,
                  ];
                  app
                    .sortBySentTime(app.contactsSearchedFromName)
                    .then((res) => {
                      app.contactsSearchedFromName = res;
                    });
                })
                .catch(function (error) {
                  console.error(error.response);
                });
            }
          }, 1000);
        }
      } else {
        app.isSearch = false;
      }
    },
    sortBySentTime(list) {
      const app = this;
      return new Promise((resolve) => {
        //app.loading = false;
        let activeClient = list.filter((item) => {
          return item.sent_time;
        });

        let inActiveClient = list.filter((item) => {
          return !item.sent_time;
        });
        resolve([
          ..._.sortBy(activeClient, "sent_time").reverse(),
          ...inActiveClient,
        ]);
      });
    },
    getModifiedText(words) {
      const app = this;
      var iQuery = new RegExp(app.searchKeyword, "ig");
      return words.toString().replace(iQuery, function (matchedTxt, a, b) {
        return "<span class='highlight'>" + matchedTxt + "</span>";
      });
    },
    changeCity() {
      const app = this;
      localStorage.setItem("activeCityID", app.userCity.toString());
      app.cityList.map((city) => {
        if (city.city_id == app.userCity) {
          app.activeCity = city;
        }
      });
      app.hasMoreItems = true;
      app.hasMoreMyItems = true;
      app.notRespondedContactEnd = false;
      this.clearContacts("reset");
      app.searchKeyword = "";
      app.isSearch = false;
      this.getUsers(false);
      this.myChats(true);
    },
    clearContacts(option) {
      const app = this;
      switch (option) {
        case ChatOptions.MyChats: {
          app.MyChatPage = 1;
          app.myChatsList = [];
          break;
        }
        case ChatOptions.All: {
          app.page = 1;
          app.userList = [];
          break;
        }
        case ChatOptions.Members: {
          app.membersPage = 1;
          app.myMemberList = [];
          break;
        }
        case "reset": {
          app.MyChatPage = 1;
          app.myChatsList = [];
          app.page = 1;
          app.userList = [];
          app.searchPage = 1;
          app.contactsSearchedFromMessage = [];
          app.contactsSearchedFromName = [];
        }
        default: {
          app.searchPage = 1;
          app.contactsSearchedFromMessage = [];
          app.contactsSearchedFromName = [];
        }
      }
    },
    clearSearchKeyword() {
      const app = this;
      app.searchKeyword = "";
      app.searchPage = 1;
      app.isSearch = false;
    },
    ageAndGender(user) {
      return `${user.client.age ? user.client.age.toString() : ""}${
        user.client.gender ? user.client.gender : ""
      }`;
    },
    filterByMembership(membershipId) {
      const app = this;
      app.membershipLevel = membershipId ? membershipId : app.membershipLevel;
      // console.log("chatOption", app.chatOption, app.membershipLevel);
      // return false;
      app.testLog("===========filterByMembership=====", app.membershipLevel);
      if (app.chatOption == ChatOptions.MyChats) {
        this.clearContacts(app.chatOption);
        app.hasMoreMyItems = true;
        app.myChatLoading = true;
        this.myChats(true);
      }
      if (app.chatOption == ChatOptions.All) {
        this.clearContacts(app.chatOption);
        app.hasMoreItems = true;
        app.notRespondedContactEnd = false;
        app.loading = true;
        this.getUsers(false);
      }
      if (app.chatOption == ChatOptions.Members) {
        this.clearContacts(app.chatOption);
        app.hasMoreMyMembers = true;
        app.myMembersLoading = true;
        this.employeeMembers();
      }
    },
    refreshContacts() {
      const app = this;

      if (app.chatOption == ChatOptions.MyChats) {
        app.myChatLoading = true;
        this.myChats(true);
      }
      if (app.chatOption == ChatOptions.All) {
        app.loading = true;
        this.getUsers(false);
      }
      if (app.chatOption == ChatOptions.Members) {
        app.loading = true;
        this.getUsers(false);
      }
    },
    addLastMsgToList(message) {
      let self = this;

      let targetId = parseInt(message.clientId);
      //   console.log("addLastMsgToList", targetId, self.chatOption, message);

      if (self.chatOption == ChatOptions.MyChats) {
        console.log();
        let index = _.findIndex(self.myChatsList, {
          client_id: targetId,
        });
        console.log("MyChats", index);
        if (index <= -1) {
          return false;
        }
        self.myChatsList[index]["from_client_id"] = 0;
        self.myChatsList[index]["to_client_id"] = targetId;
        self.myChatsList[index]["to_employee_id"] = 0;
        self.myChatsList[index]["from_employee_id"] = 1;
        self.myChatsList[index]["msg"] = message.message;
        self.myChatsList[index]["sent_time"] = new Date().getTime();
      }

      if (self.chatOption == ChatOptions.All) {
        let index = _.findIndex(self.userList, { client_id: targetId });
        console.log("ALL", index);
        if (index <= -1) {
          return false;
        }

        self.userList[index]["from_client_id"] = 0;
        self.userList[index]["to_client_id"] = targetId;
        self.userList[index]["to_employee_id"] = 0;
        self.userList[index]["from_employee_id"] = 1;
        self.userList[index]["msg"] = message.message;
        self.userList[index]["sent_time"] = new Date().getTime();
      }

      if (self.chatOption == ChatOptions.Members) {
        let index = _.findIndex(self.myMemberList, {
          client_id: targetId,
        });
        console.log("Members", index);
        if (index <= -1) {
          return false;
        }

        self.myMemberList[index]["from_client_id"] = 0;
        self.myMemberList[index]["to_client_id"] = targetId;
        self.myMemberList[index]["to_employee_id"] = 0;
        self.myMemberList[index]["from_employee_id"] = 1;
        self.myMemberList[index]["msg"] = message.message;
        self.myMemberList[index]["sent_time"] = new Date().getTime();
      }
    },
  },
  computed: {},
  mounted: function () {
    const app = this;

    let iscn = 0;
    if (
      location.pathname.indexOf("shenzhen") > -1 ||
      location.pathname.indexOf("china") > -1
    ) {
      iscn = 1;
    }
    app.cnpath = iscn;

    app.activeClientId = !_.isEmpty(
      this.$f7route.query && this.$f7route.query.clientId
    )
      ? this.$f7route.query.clientId
      : "";
    if (app.userInfo.data.city_id == DefaultValue.employee_city_id) {
      app.cityList = [];
    } else {
      let cityList = JSON.parse(localStorage.getItem("cities"));
      app.cityList = cityList.filter((city) => {
        return (
          app.userInfo.data.availableCityIds.includes(city.city_id) &&
          city.is_active == 1
        );
      });
    }

    this.type = this.user.isEmployee ? "employee" : "client";

    app.currentUser = _.get(
      JSON.parse(localStorage.getItem("userInfoData")),
      "data"
    );
    // console.log("app.currentUser", app.currentUser);

    localStorage.setItem("tabStatus", "0");
    if (app.cityList.length > 0) {
      localStorage.setItem(
        "activeCityID",
        app.cityList[0]["city_id"].toString()
      );
      app.activeCity = app.cityList[0];
    }
    app.site = JSON.parse(localStorage.getItem("cur-site"));
    app.selectedUser = !_.isEmpty(
      this.$f7route.query && this.$f7route.query.user
    )
      ? JSON.parse(this.$f7route.query.user)
      : {};
    // this.getUsers(false);
    // this.myChats(true);
    // this.employeeMembers();
    this.changeTab(1);

    if (app.imMode == "tim") {
      //   console.log("app.userInfo home=", app.userInfo);
      app.tencentImUserID = _.get(
        app.userInfo,
        "data.common_tencent_im_userID"
      );
      app.tencentImSig = _.get(app.userInfo, "data.common_tencent_im_sig");
      app.initTIM();
    }

    // if (app.imMode == "websocket") {
    //   this.socket = io("https://im.lovestruck.com", {
    //     //   socket: io("http://localhost:3002", {
    //     // path: "/chat.io",
    //     query: {
    //       token: JSON.parse(localStorage.getItem("user")).token,
    //       // token: getQueryVariable('userType') === 'employee' ? employeeToken : clientToken,
    //       // token: invalidFormatToken
    //     },
    //   });

    //   this.socket.on("message", (data) => {
    //     console.log("message from client", data);
    //     if (
    //       app.user.isEmployee &&
    //       data.clientId &&
    //       app.activeClientId == data.clientId
    //     ) {
    //       this.readConversation(data.clientId);
    //     } else {
    //       if (
    //         app.chatOption == ChatOptions.MyChats &&
    //         (app.userCity == data.cityId || data.cityId == "")
    //       ) {
    //         app.MyChatPage = 1;
    //         this.myChats(true);
    //       }
    //       if (
    //         app.chatOption == ChatOptions.All &&
    //         (app.userCity == data.cityId || data.cityId == "")
    //       ) {
    //         app.page = 1;
    //         this.getUsers(false);
    //       }
    //     }
    //     // app.isSearch = false;
    //   });
    //   this.socket.on("message_sent", (data) => {
    //     console.log("message from employee", data);
    //     self.addLastMsgToList(data);
    //     if (
    //       app.chatOption == ChatOptions.MyChats &&
    //       app.userCity == data.cityId &&
    //       data.clientId &&
    //       app.user.id == data.clientId
    //     ) {
    //       app.MyChatPage = 1;
    //       this.myChats(true);
    //     }
    //     /*      if (app.chatOption == ChatOptions.All && app.userCity == data.cityId) {
    //       app.page = 1;
    //       this.getUsers(false);
    //   }*/
    //   });
    // }

    if (app.activeClientId) {
      this.$http
        .get(`/api/v2/client/profile?clientId=${app.activeClientId}`, {
          headers: {
            "Accept-Language": "en_US",
          },
        })
        .then((response) => {
          // console.log('client/profile', response)
          const data = {
            client_first_name: encodeURIComponent(
              response.data.client.first_name
            ),
            client_last_name: encodeURIComponent(
              response.data.client.last_name
            ),
            client_photo_url: encodeURIComponent(
              response.data.client.primary_photo
            ),
            client_age: response.data.client.age,
            client_gender: response.data.client.gender,
            from_client_id: response.data.client.client_id,
            phone: `+${response.data.client.country_phone_code}${response.data.client.phone_number}`,
            // sent_time: _.get(response, "data.client.last_msg.sent_time", 0),
            last_active_time: _.get(
              response,
              "data.client.last_active_timestamp",
              0
            ),
            status: _.get(
              response,
              "data.client.client_status.description",
              ""
            ),
            membership_level:
              response.data.client.cur_membership_level.description,
            total_paid_amount: response.data.client.total_paid_amount
              ? response.data.client.total_paid_amount
              : 0,
            date_credits_str: encodeURIComponent(
              `${
                _.get(response.data, "client.date_credits")
                  ? _.get(response.data, "client.date_credits")
                  : 0
              } Date Credits`
            ),
            payment_count: encodeURIComponent(
              `${_.get(response.data, "client.paidCount", 0)} payments`
            ),
          };
          this.$f7router.navigate(
            `/tim-conversation/${app.activeClientId}/?user=${JSON.stringify(
              data
            )}`
          );
        });
    }

    /* setInterval(function() {
      let status = localStorage.getItem("msg");
      if (status == "received" && app.isSearch) {
        localStorage.setItem("msg", "");
        app.getUsers();
        app.isSearch = false;
      }
      if (status == "received" && !app.isSearch) {
        localStorage.setItem("msg", "");
        app.getUsers();
      }
    }, 500);*/
  },
  watch: {
    userCity: function (oldCity, newCity) {
      this.clearContacts("reset");
      this.loading = true;
      this.myChatLoading = true;
    },
    searchKeyword: function (value) {
      this.searchPage = 1;
      this.contactsSearchedFromMessage = [];
      this.contactsSearchedFromName = [];
    },
  },
};
</script>
